export default __webpack_public_path__ + "static/media/We_Will_Be_Okay.5e97f193.mp3";